import { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import styles from './staffPreparationTaskDialog.module.scss'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import {
    CREATE_STAFF_PREPARATION_TASK,
    GET_STAFF_PREPARATION_TASKS_BY_DAYCARE
} from '@/modules/API/staff/staffPreparationTask'
import StaffPreparationTaskForm from './staffPreparationTaskForm'
import { StaffPreparationTaskDialogCreateProps } from './staffPreparationTaskDialog'

const CreateStaffPreparationTaskDialog: FunctionComponent<StaffPreparationTaskDialogCreateProps> = ({
    open,
    handleClose,
    daycare,
    addOneStaffPreparationTask
}) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [newName, setNewName] = useState<string>('')
    const [newDuration, setNewDuration] = useState<string>('')
    const [verifyDuration, setVerifyDuration] = useState<boolean>(true)

    const [createStaffPreparationTask] = useMutation(CREATE_STAFF_PREPARATION_TASK, {
        variables: {
            daycareId: daycare.id,
            staffPreparationTask: {
                name: newName,
                duration: parseInt(newDuration)
            }
        },
        refetchQueries: [{ query: GET_STAFF_PREPARATION_TASKS_BY_DAYCARE, variables: { daycareId: daycare.id } }],
        onCompleted: ({ createStaffPreparationTask: createdId }) => {
            addOneStaffPreparationTask({
                id: createdId,
                daycareId: daycare.id,
                name: newName,
                duration: parseInt(newDuration)
            })

            setNewName('')
            setNewDuration('')

            handleClose()

            showNotificationSuccess(t('staffPreparationTaskAdded'))
        },
        onError: () => {
            showNotificationError(t('errorAddedStaffPreparationTask'))
        }
    })

    const disabled: boolean = !verifyDuration || newName === '' || newDuration === ''

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('addStaffPreparationTask')} />
            <DialogBody className={styles.DialogBody}>
                <StaffPreparationTaskForm
                    name={newName}
                    setName={setNewName}
                    duration={newDuration}
                    setDuration={setNewDuration}
                    setDurationValid={setVerifyDuration}
                />
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleClose} className={styles.Button} />
                    <ButtonTextIcon
                        type={'add'}
                        onClick={createStaffPreparationTask}
                        className={styles.Button}
                        disabled={disabled}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default CreateStaffPreparationTaskDialog
